import gsap from 'gsap';
import { SplitText } from 'gsap/SplitText';

import ScrollController from './scroll';

import { getRootOffset } from '../helpers';

gsap.registerPlugin(SplitText);

class TransitionController {

	container;
	header;
	uri;

	timelineIn;

	timelineOut;
	timelineOut2;
	timelineOut3;

	isPreload;
	isNextTransition;

	initialize(header, footer, main) {
		this.header = header;
		this.footer = footer;
		this.main = main;
	}

	/**
	 * Animations.
	 */

	show(page, isPreload = false, isNextTransition = false) {
		this.isPreload = isPreload;
		this.isNextTransition = isNextTransition;
		this.container = page;
		this.uri = page.dataset.uri;

		this.timelineHeaderIn = gsap.timeline();

		if (this.isPreload) {
			this.timelineHeaderIn
				.set(this.header.wrap, {
					autoAlpha: 1
				}, 'start')
				.fromTo(this.header.logo, {
					y: 30,
					autoAlpha: 0,
				}, {
					ease: 'expo.out',
					duration: 1,
					y: 0,
					autoAlpha: 1,
					delay: this.uri === 'home' ? 2.35 : 1.35
				}, 'start')
				.fromTo(this.header.items, {
					y: 30,
					autoAlpha: 0,
				}, {
					ease: 'expo.out',
					duration: 1,
					y: 0,
					autoAlpha: 1,
					delay: this.uri === 'home' ? 2.35 : 1.35,
					stagger: 0.06,
				}, 'start');
		} else {
			const delay = this.uri === 'home' || this.uri === 'about' || this.uri === 'contact' ? 1.5 : 0;
			const nextDelay = this.isNextTransition ? 0.25 : 0.5;

			this.timelineHeaderIn
				.call(() => {
					this.header.wrap.style.pointerEvents = 'all';
				}, null, `start+=${delay}`)
				.set(this.header.wrap, {
					autoAlpha: 1
				}, `start+=${nextDelay}`)
				.fromTo(this.header.logo, {
					y: 30,
					autoAlpha: 0,
				}, {
					ease: 'expo.out',
					duration: 1,
					y: 0,
					autoAlpha: 1
				}, `start+=${nextDelay}`)
				.fromTo(this.header.items, {
					y: 30,
					autoAlpha: 0,
				}, {
					ease: 'expo.out',
					duration: 1,
					y: 0,
					autoAlpha: 1,
					stagger: 0.06,
				}, `start+=${nextDelay}`);

			this.footer.style.opacity = '';
		}
	}

	hide(page, params = { type: 'default' }) {
		this.container = page;

		this.timelineHeaderOut = gsap.timeline();
		this.timelineHeaderOut
			.set(this.header.wrap, {
				pointerEvents: 'none'
			})
			.fromTo(this.header.wrap, {
				autoAlpha: 1,
			}, {
				ease: 'power4.inOut',
				autoAlpha: 0,
				duration: 0.5,
			});

		if (params.type === 'case-study') {
			return this.hideCaseStudy();
		}

		if (params.type === 'news-detail') {
			return this.hideNewsDetail(params.currentAnchor);
		}

		return this.hideDefault();
	}

	hideNewsDetail(current) {
		const { nextElementSibling } = current;
		const { parentElement } = nextElementSibling;
		parentElement.classList.add('is-transition');
		parentElement.parentElement.classList.add('is-transition');

		const hideItems = this.container.querySelectorAll('.grid-news__item:not(.is-transition)');
		const hideFilters = this.container.querySelector('.grid-news__filters');

		const currentImage = {
			el: nextElementSibling,
			meta: nextElementSibling.nextElementSibling,
			top: nextElementSibling.getBoundingClientRect().top,
			width: nextElementSibling.clientWidth,
			scale: nextElementSibling.clientWidth / window.innerWidth,
			left: parentElement.offsetLeft
		};

		const nextRef = this.container.querySelector('.hero-news-landing__ref');
		const nextRefTop = getRootOffset(nextRef).top;
		const nextScale = 0.284993055555556;

		const offsetScale = nextScale / currentImage.scale;

		return new Promise(resolve => {
			this.timelineOut = gsap.timeline({
				onComplete: () => {
					resolve();
				}
			});
			this.timelineOut
				.to([...hideItems, hideFilters, currentImage.meta], {
					ease: 'power4.inOut',
					duration: 0.5,
					autoAlpha: 0
				}, 'start')
				.to(currentImage.el, {
					ease: 'power4.inOut',
					duration: 1.25,
					scale: offsetScale,
					transformOrigin: 'top right',
					y: (currentImage.top - nextRefTop) * -1,
					x: !currentImage.left ? currentImage.el.closest('.row').clientWidth - currentImage.width : 0
				}, 'start');
		});
	}

	hideCaseStudy() {
		const refHeading = this.container.querySelector('.hero-case-study__content h1');
		const refTop = getRootOffset(refHeading).top;

		const nextContainer = this.container.querySelector('.next-case-study');
		// const nextBackground = nextContainer.querySelector('.next-case-study__background');
		const nextHeadingFg = nextContainer.querySelector('.next-case-study__heading-fg');
		const nextHeadingBg = nextContainer.querySelector('.next-case-study__heading-bg');
		const nextEyebrowFg = nextContainer.querySelector('.next-case-study__eyebrow-fg');

		if (nextHeadingFg) {
			const nextHeadingTop = getRootOffset(nextHeadingFg).top - ScrollController.eased;
			nextContainer.classList.add('is-transition');
			nextContainer.style.backgroundColor = 'transparent';

			return new Promise(resolve => {
				this.timelineOut = gsap.timeline();
				this.timelineOut
					.to([nextHeadingBg, nextHeadingFg, nextEyebrowFg], {
						ease: 'expo.inOut',
						duration: 1,
						y: -(nextHeadingTop - refTop)
					}, 'start')
					.to([nextHeadingFg, nextEyebrowFg], {
						ease: 'expo.inOut',
						duration: 1,
						autoAlpha: 0
					}, 'start')
					// .to(nextBackground, {
					// 	ease: 'expo.inOut',
					// 	duration: 1,
					// 	y: -(nextHeadingTop - refTop),
					// 	autoAlpha: 0
					// }, 'start')
					.to(nextContainer.previousElementSibling, {
						ease: 'expo.inOut',
						duration: 0.85,
						autoAlpha: 0
					}, 'start')
					.call(() => {
						resolve();
					});
			});
		}
	}

	hideDefault() {
		const visibleSections = this.main.querySelectorAll('[data-module]:not([style*="visibility: hidden"])');
		const animSections = [];

		let animHeading = null;
		let animHeadingSub = null;
		let animContent = null;

		for (const section of visibleSections) {
			if (section.classList.contains('hero')) {
				const { top } = section.getBoundingClientRect();
				if (top >= 0) {
					animHeading = section.querySelector('.h1');
					animHeadingSub = section.querySelector('.h3');
					animContent = section.querySelectorAll('.content-secondary');
				} else {
					animSections.push(section);
				}
			} else {
				animSections.push(section);
			}
		}

		if (animSections.length || animHeading || animHeadingSub) {
			return new Promise(resolve => {
				this.timelineOut = gsap.timeline({
					onComplete: () => {
						resolve();
					}
				});

				if (animSections.length) {
					this.timelineOut
						.to(animSections, {
							ease: 'power4.inOut',
							autoAlpha: 0,
							duration: 0.5
						}, 'start');
				}

				if (animHeading) {
					const split = new SplitText(animHeading, {
						type: 'lines'
					});

					const rotations = [30, 25, 15, 10, 5];

					for (const [i, line] of split.lines.entries()) {
						const offset = split.lines[0].offsetHeight * ((i + 1) * 0.6) * (-1 + i * 0.125);
						this.timelineOut
							.to(line, {
								ease: 'power4.inOut',
								autoAlpha: 0,
								rotationX: rotations[i],
								y: offset,
								duration: 1,
								transformOrigin: '50% 50% -150',
								delay: i === 0 ? 0 : i * 0.1
							}, 'start');
					}
				}

				if (animHeadingSub) {
					this.timelineOut2 = gsap.timeline();
					this.timelineOut2
						.to(animHeadingSub, {
							ease: 'power4.inOut',
							duration: 0.5,
							autoAlpha: 0
						}, 'start');
				}

				if (animContent && animContent.length) {
					this.timelineOut3 = gsap.timeline();
					this.timelineOut3
						.to(animContent, {
							ease: 'power4.inOut',
							duration: 0.5,
							autoAlpha: 0
						}, 'start');
				}
			});
		}

		return new Promise(resolve => {
			resolve();
		});
	}

}

export default new TransitionController();
